import { RESET_STATE } from 'store/global/actions';

import { DISCLOSURE_ACTIVITY_ACTION_TYPE } from '../actions';

const initialState = {
  entries: [],
  isUnavailable: false,
};

const disclosureActivityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DISCLOSURE_ACTIVITY_ACTION_TYPE.GET_ACTIVITY:
      return {
        entries: payload?.entries ?? initialState.entries,
        isUnavailable: !!payload?.isUnavailable,
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default disclosureActivityReducer;
